export { default as GroupListingPage } from './components/GroupListingPage';

export const GroupListingPageDynamic = () => import('./components/GroupListingPage');

export { default as GroupDetailsPage } from './components/GroupDetailsPage';

export const GroupDetailsPageDynamic = () => import('./components/GroupDetailsPage');

export { default as DeleteLearnersModal } from './components/modals/DeleteLearnersModal';
